/** Block + house label for complaint cards (matches member registration format). */
export function formatPlotAddress(
  block?: string | null,
  house?: string | null
): string | null {
  const b = block?.trim();
  const h = house?.trim();
  if (b && h) return `Block ${b}, House ${h}`;
  if (b) return `Block ${b}`;
  if (h) return `House ${h}`;
  return null;
}

export function getComplaintPlotLabel(complaint: {
  block_number?: string;
  flat_number?: string;
  user?: { block_number?: string; flat_number?: string };
}): string | null {
  const block = complaint.block_number || complaint.user?.block_number;
  const house = complaint.flat_number || complaint.user?.flat_number;
  return formatPlotAddress(block, house);
}
